const validation = (regex, value) => {
  if (value === "" || regex.test(value.trim())) {
    return true;
  }
  return false;
};

export const numberValidation = (value) => {
  return validation(/^[0-9\b]+$/, value);
};

export const alphaNumValidation = (value) => {
  return validation(/^[ A-Za-z0-9]+$/, value);
};

export const useStyleObject = {
  card: {
    //maxWidth: 420,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "12px 7px 5px #00000033",
    borderRadius: 24,
  },
  container: {
    display: "Flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    fontFamily: `"Open Sans", sans-serif`,
    flexDirection: "column",
  },
  actions: {
    alignItems: "center",
    justifyContent: "center",
  },
  outlinedBorder: {
    fontFamily: `"Open Sans", sans-serif`,
    background: "#F4F7FC",
    borderRadius: 4,
  },
  disabled: {
    fontFamily: `"Open Sans", sans-serif`,
    background: "#EBECED",
    borderRadius: 4,
  },
  logo: {
    display: "flex",
    justifyContent: "center",
  },
  topImage: {
    width: 100,
    height: 100,
  },
  accImage: {
    width: 50,
    height: 50,
  },
  title: {
    fontSize: 18,
    color: "#000000",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 16,
    marginBottom: 16,
  },
  subText: {
    fontSize: 14,
    color: "#000000",
  },
  formControlLabelRoot: {
    marginTop: 4,
    marginBottom: 4,
  },
  formControlLabelRadio: {
    flexDirection: "row",
  },
  formHelperText: {
    marginLeft: 14,
    marginRight: 14,
    marginBottom: 4,
  },
  radioLabel: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#000000",
    marginTop: 4,
  },
  mBottom: {
    marginBottom: 16,
  },
  liteImage: {
    width: 250,
    height: "auto",
  },
  cardcontent: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  formControlLabelNewRoot: {
    marginTop: 4,
    marginBottom: 4,
    border: "2px solid #4141AF",
    borderRadius: "8px",
  },
  // radio: {
  //   "&$checked": {
  //     color: "#4B8DF8",
  //   },
  // },
  // checked: {},
};

export const inlineStyleObject = {
  bg: {
    background: "#F7F9F9 0% 0% no-repeat padding-box",
  },
  title: {
    color: "#FAFAFB",
    fontWeight: 400,
    textAlign: "center",
  },
  termsContainer: {
    fontSize: 14,
    color: "#000000",
    fontWeight: 600,
  },
  termsColor: {
    color: "#4141AF",
  },
  regFailureMsg: {
    color: "#B53E4E",
    fontSize: 16,
    textAlign: "center",
    margin: "16px 0",
  },
  regButton: {
    width: 114,
    height: 40,
    borderRadius: 4,
    fontSize: 14,
    color: "#FFF",
    background: "#4141AF 0% 0% no-repeat padding-box",
    boxShadow: "none",
    textTransform: "unset",
    fontWeight: "bold",
  },
  clickHereBtn: {
    color: "#4141AF",
    textDecoration: "none",
  },
};
